module.exports = __webpack_public_path__ + "img/closeMark01.db037a9d.png";